module.exports = __webpack_public_path__ + "img/icecreamwaifuprizezach.584d1feb.png";